/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Link, InputLabel } from "@mui/material";

export const StyledBreadCrumbContainer = styled("div")({
  height: "20px",
  width: "100%",
  backgroundColor: "#f5f5f8",
  padding: "10px 0px 10px 20px",
  borderColor: "#e0e0e0",
  borderWidth: "0px 0px 1px 0px",
  borderStyle: "solid",
});

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: "none",
  color: color,
  fontSize: "13px",
  fontWeight: "400",
}));

export const StyledInputLabel = styled(InputLabel)({
  fontSize: "14px",
});

export const viewTypographyStyles = {
  color: "#666",
  fontSize: "0.875rem",
};

export const selectBaseStyles = {
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};

export const filterContainerStyles = {
  backgroundColor: "#f5f5f8",
  justifyContent: "space-between",
  padding: 1,
  border: "1px solid #e0e0e0",
  mt: 2,
  mb: 2,
};

export const datePickerStyles = {
  maxWidth: 150,
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "& .MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};
